/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Card, Spinner } from "reactstrap";

//Redux
import { useSelector, useDispatch } from "react-redux";

// actions
import { getClientInfo } from "../../../../store/clientInformation/actions";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "../../../../assets/scss/custom.scss"

//Custom components
import MenuButtons from "../PreviousConversations/subcomponents/MenuButtons";
import ClientInfoArea from "./subcomponents/ClientInfoArea/ClientInfoArea.js";

const ClientInformation = ({ chatId, update, time, moreOptions, moreOptionsVisible, id }) => {
  const { info: chatInfo, status } = useSelector(
    (state) => state.ClientInformation
  );

  // States
  const [data, setData] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (chatId && (!chatInfo[chatId] || update)) {
      dispatch(getClientInfo(chatId));
    }
    setData(chatInfo[chatId]);
  }, [chatId, update, dispatch]);

  useEffect(() => {
    if (status?.get_info) {
      if (chatInfo && chatInfo[chatId] && status?.get_info?.success) {
        setData(chatInfo[chatId]);
      } else setData(null);
    }
  }, [chatInfo]);

  return (
    <Card className="user-chat h-100 client-info-card">
      <MenuButtons
        type="chatInformation"
        chatId={chatId}
        enableMoreOptions = {moreOptionsVisible}
        moreOptions={{ options: moreOptions }}
        moreOpAction={(e) => {
          moreOptions.find((element) => element.value === e)?.action();
        }}
      />
      <div
        className="chat-conversation h-100 p-0"
        style={{
          overflow: "auto",
        }}
      >
        <PerfectScrollbar className="pt-0 quickRepliesScrollbar" id="engagementScroll" >
          {status?.get_info?.loading ? (
            <div className="w-100 text-center">
              <Spinner animation="border" size="sm" className="spinner" />
            </div>
          ) : (
            <ul className="list-unstyled mt-1">
              <ClientInfoArea data={data} chatId={chatId} time={time} />
            </ul>
          )}
        </PerfectScrollbar>
      </div>{" "}
    </Card>
  );
};
export default ClientInformation;
